import React from 'react';

const TaskWorkspaceShell = ({ children, className = '' }) => {
    return (
        <div className={`relative min-h-screen overflow-hidden bg-gradient-to-br from-[#fff8f5] via-[#fffdfb] to-[#EDE4DA] p-4 md:p-6 ${className}`}>
            <div className="pointer-events-none absolute -top-24 right-[-6rem] h-72 w-72 rounded-full bg-[#FF9A6B]/15 blur-3xl" />
            <div className="pointer-events-none absolute left-[-5rem] top-32 h-64 w-64 rounded-full bg-white/70 blur-3xl" />
            <div className="pointer-events-none absolute bottom-[-6rem] right-24 h-72 w-72 rounded-full bg-[#ffd6c6]/35 blur-3xl" />
            <div className="relative z-10 mx-auto max-w-7xl space-y-5">
                {children}
            </div>
        </div>
    );
};

export default TaskWorkspaceShell;
